import {
  IllustrationStyleKey,
  ProgressBarComponent,
  Typenames,
} from '@varo/graphql-schema-types';
import { TrackerProps } from 'shared/components/vxl/Tracker/Tracker';
import { TrackerTextureSourceType } from 'shared/components/vxl/Tracker/TrackerTexture/TrackerTexture';
import { VXLComponentId, VXLNode } from 'shared/renderer/types';
import theme from 'shared/styles/theme';
import { getVXLColor } from 'shared/utils/getVXLColor/getVXLColor';
import { Maybe } from 'shared/utils/types';

const progressBarComponent = (component: ProgressBarComponent): VXLNode => {
  const { id, percentage, fillStyle } = component;

  const backgroundTexture: Maybe<TrackerTextureSourceType> = (() => {
    if (fillStyle.__typename === Typenames.IllustrationStyleDictionary) {
      if (
        fillStyle.illustrationKey ===
        IllustrationStyleKey.DmgmTrackerTextureMint
      ) {
        return 'SEAFOAM';
      } else if (
        fillStyle.illustrationKey ===
        IllustrationStyleKey.DmgmTrackerTextureGray
      ) {
        return 'GREY_B';
      }
    }
    return null;
  })();

  const fillColor: Maybe<string> = (() => {
    if (fillStyle.__typename === Typenames.VXLColorType) {
      return getVXLColor(fillStyle.color);
    }
    return null;
  })();

  return {
    id: id,
    name: VXLComponentId.TRACKER,
    props: {
      trackerType: 'SIMPLE',
      progressValue: percentage,
      backgroundTexture,
      fillColor,
      backgroundColor: theme.color.background.tertiary,
      hasAnimation: true,
    } satisfies TrackerProps,
  };
};

export default progressBarComponent;
